(function ($) {
  $(document).ready(function ($) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;

    /*****************************************************************
      Touch fix for devices to mimick hover effects
    ******************************************************************/
    $("*")
      .on("touchstart", function () {
        $(this).trigger("hover");
      })
      .on("touchend", function () {
        $(this).trigger("hover");
      });

    /*****************************************************************
      For when we do a img src="example.svg" SVG use instead of the
      <svg> html markup
    ******************************************************************/
    $("img.svg").each(function () {
      var $img = $(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");
      var dataFill = $img.attr("data-fill-color");
      var dataStroke = $img.attr("data-stroke-color");
      $.get(
        imgURL,
        function (data) {
          // Get the SVG tag, ignore the rest
          var $svg = $(data).find("svg"),
            $svgElements = $(data).find("svg *");
          // Add replaced image's ID to the new SVG
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          // Add replaced image's classes to the new SVG
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", imgClass + " replaced-svg");
          }

          if ($img.parent(".svg-egg").length) {
            $svgElements = $svgElements.removeAttr("stroke");
          }
          // Add Fill color of SVG
          if (typeof dataFill !== "undefined") {
            $svg = $svg.attr("fill", dataFill);
          }

          // Add Stroke color of SVG
          if (typeof dataStroke !== "undefined") {
            $svg = $svg.attr("stroke", dataStroke);
          }

          // Remove any invalid XML tags as per http://validator.w3.org
          $svg = $svg.removeAttr("xmlns:a");

          // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
          if (!$svg.attr("viewBox") && $svg.attr("height") && $svg.attr("width")) {
            $svg.attr("viewBox", "0 0 " + $svg.attr("height") + " " + $svg.attr("width"));
          }
          // Replace image with new SVG
          $img.replaceWith($svg);
        },
        "xml"
      );
    });

    /*****************************************************************
      Animation Library / Area.
      GSAP + GSAP ScrollTrigger
    ******************************************************************/
    gsap.registerPlugin(ScrollTrigger);

    // GSAP Custom Parallax
    gsap.utils.toArray("[data-gsap]").forEach((el) => {
      const obj = eval("(" + el.dataset.gsap + ")");
      // Scroll Options
      const scrollProps = {
        scrollTrigger: {
          start: "top bottom",
          end: "bottom top",
          trigger: el,
          scrub: 0.5, // Sets a 0.5 second delay, true is default for scrub
          // markers: true,
        },
      };
      // Add values to object from element data attribute
      Object.assign(scrollProps, obj);

      gsap.to(el, scrollProps);
    });

    // Scroll into view section animations
    gsap.utils.toArray(".fade-in-up").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    gsap.utils.toArray(".fade-in").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    gsap.utils.toArray(".line-reveal").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    gsap.utils.toArray(".scroll-custom").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 90%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          // onEnter: ({progress, direction, isActive}) => {
          //   if (isActive) {
          //     $(el).addClass("show");
          //   }
          // },
          // markers: true,
        },
      });
    });

    // Announcement Carousel
    if ($(".announcement-bar-carousel").length) {
      $(".announcement-bar-carousel .owl-carousel")
        .owlCarousel({
          autoplay: true,
          autoplayTimeout: 2500,
          autoplaySpeed: 500,
          autoplayHoverPause: true,
          loop: true,
          margin: 0,
          nav: false,
          dots: false,
          items: 1,
          slideBy: 1,
        })
        .on("changed.owl.carousel", function (event) {
          $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
          $(this).trigger("play.owl.autoplay"); // user performs any actions
        });
    }

    // Featured Carousel
    if ($(".featured-collections-alt.carousel-side").length) {
      $(document).on(
        "scroll.flickity",
        ".featured-collections-alt.carousel-side .Carousel, .featured-collections-alt.carousel-side .product-reco-carousel, .rebuy-carousel-custom",
        function (e, progress) {
          progress = Math.max(0, Math.min(1, progress)) + 0.1;

          $(this)
            .parent()
            .find(".progress-bar .prog")
            .width(progress * 91 + "%");
        }
      );

      if (isMobile) {
        var scrEl = $(
          ".featured-collections-alt.carousel-side .Carousel, .featured-collections-alt.carousel-side .product-reco-carousel"
        );

        scrEl.each(function (index, el) {
          var $this = $(el)[0];

          $this.addEventListener("scroll", (event) => {
            var scrolled = ($this.scrollLeft / ($this.scrollWidth - $this.clientWidth)) * 90;

            $(el)
              .parent()
              .find(".progress-bar .prog")
              .width(scrolled + 10 + "%");
          });
        });
      }
    }

    // $(window).on("scroll", function (e) {
    //   horizontal = e.currentTarget.scrollLeft;
    //   vertical = e.currentTarget.scrollTop;

    //   console.log("anything");

    // });

    // $(".flickity-slider").on("mousewheel", function (e, delta) {

    //   $(this).css({ transform: "translateX(" + delta + "%)" });
    //   e.preventDefault();

    //   // if (e.deltaY === 0) {
    //   //   // console.log(e.deltaX);
    //   // }
    // });

    /*****************************************************************
     * Menu
     *****************************************************************/
    // Helps with Mobiel Icon Colors and menu transitions
    if ($("header#section-header").hasClass("Header--transparent")) {
      $('[data-action="open-drawer"]').on("click", function () {
        $("header#section-header").removeClass("Header--transparent");
      });

      $('[data-action="close-drawer"]').on("click", function () {
        $("header#section-header").addClass("Header--transparent");
      });
    }

    /*****************************************************************
     * Mega Menu
     *****************************************************************/

    $(".Header__MainNav li").each(function () {
      var $this = $(this);
      var $megaMenu = $this.find(".MegaMenu");
      var timeoutId;

      $this.hover(
        function () {
          // On mouse enter, remove any pending class removal and add the class
          clearTimeout(timeoutId);
          $this.addClass("is-expanded");
          $megaMenu.attr("aria-hidden", false);
        },
        function () {
          // On mouse leave, set a timeout to remove the class after a delay
          timeoutId = setTimeout(function () {
            $this.removeClass("is-expanded");
            $megaMenu.attr("aria-hidden", true);
          }, 0); // Change the delay here
        }
      );
    });

    /*****************************************************************
     * Mobile Menu
     *****************************************************************/
    $(".Collapsible__Button").on("click", function () {
      var $toggleButton = $(this);
      var $collapsibleInner = $toggleButton.siblings(".Collapsible__Inner");

      if ($toggleButton.attr("aria-expanded") === "false") {
        $toggleButton.attr("aria-expanded", "true");
      } else {
        $toggleButton.attr("aria-expanded", "false");
      }

      $collapsibleInner.slideToggle(200);
    });
  }); // end .ready()
})(jQuery);
